import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono-jl inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.32em] text-[#00C8FF] sm:text-xs ${className}`}>
    <span className="h-px w-8 bg-gradient-to-r from-transparent to-[#00C8FF]" />
    {children}
  </p>
);

const LINE = { hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 1.1, ease: EASE } } };

export const MaskLines = ({ lines, className = "", delay = 0, inView }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    variants={{ show: { transition: { staggerChildren: 0.12, delayChildren: delay } } }}
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className="block" variants={LINE}>{line}</motion.span>
      </span>
    ))}
  </motion.span>
);
